import React, { PropsWithChildren, useRef, useState } from 'react';
import { FadeContainer } from './fade-container';
import { FadeButton } from './fade-button';
import { SectionVlimitWrapper, vSection } from './style';

export const VLIMIT_HEIGHT = 346;

const DATA_QA = 'section-content-vlimited';

export type SectionVlimitProps = {
  onCollapsedToggle: (cancelAnimations?: boolean) => void;
  onSendAnalytics?: (isFade: boolean) => void;
} & PropsWithChildren;

export const SectionVlimit: React.FC<SectionVlimitProps> = ({
  onCollapsedToggle,
  onSendAnalytics,
  children,
}) => {
  const vSectionRef = useRef<HTMLDivElement | null>(null);
  const [isFadeContainerRender, setIsFadeContainerRender] = useState(false);
  const [isFade, setFade] = useState(true);

  const handleClick = () => {
    setFade(!isFade);
    if (onSendAnalytics) onSendAnalytics(!isFade);
  };

  React.useEffect(() => {
    onCollapsedToggle(true);
  }, [isFade, onCollapsedToggle]);

  React.useEffect(() => {
    const clientHeight = vSectionRef.current?.children[0]?.clientHeight;

    if (clientHeight && clientHeight > VLIMIT_HEIGHT) {
      setIsFadeContainerRender(true);
    }
  }, []);

  const carouselHeight = { height: `${isFadeContainerRender && isFade ? `${VLIMIT_HEIGHT}px` : 'auto'}` };

  return (
    <SectionVlimitWrapper data-qa={DATA_QA}>
      <div ref={vSectionRef} className={vSection} style={carouselHeight}>
        {children}
      </div>
      {isFadeContainerRender && (
        <>
          {isFade && <FadeContainer />}
          {<FadeButton open={isFade} onClick={handleClick} />}
        </>
      )}
    </SectionVlimitWrapper>
  );
};
